// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5426":"fff13cf2","7860":"256874b6"}[chunkId] + ".chunk.css";
};